/**
 * Gate the change for replacing the pagination buttons with IconButtons with this setting. * Figma: https:www.figma.com/file/XoRgEwijPOdbrAvnzlO1bO/Slate-Labs-Components?type=design&node-id=772-488&mode=design&t=5iSAyHWUVXfzF0LJ-0
 */
export const ENABLE_ICON_BUTTON_PAGINATION_240430 = 'ENABLE_ICON_BUTTON_PAGINATION_240430';
